import type {
  Order,
  OrderSalesChannel,
} from '@modules/Dashboard/pages/Contributions/pages/Orders/pages/OrdersList/types'

import type { UseOrdersQueryParams } from './useOrdersQuery'

export type OrdersQueryParams = {
  currentPage: number
  size: number
  offerId?: string
  query?: string
  status?: Order['status'][]
  sales?: OrderSalesChannel[]
  types?: Order['type'][]
  filterOutGiveawayGifts?: boolean
}

export const createUseOrdersQueryParams = ({
  currentPage,
  size,
  offerId,
  query,
  status,
  sales,
  types,
  filterOutGiveawayGifts,
}: OrdersQueryParams): UseOrdersQueryParams => ({
  page: currentPage - 1,
  size,
  offerIds: offerId ? [offerId] : undefined,
  status,
  sales,
  types,
  q: query,
  filterOutGiveawayGifts,
})
